import React, { useState } from "react";
import { services } from "../data/siteData";
import useScrollReveal, { revealUp } from "../hooks/useScrollReveal";
import "./Services.css";

export default function Services() {
  const [activeId, setActiveId] = useState(services[0].id);
  const active = services.find((s) => s.id === activeId);

  const sectionRef = useScrollReveal(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".services__item"), {
      ...revealUp(null, el.querySelector(".services__list")),
      x: -20,
      y: 0,
      stagger: 0.06,
    });
    gsap.from(el.querySelector(".services__visual"), revealUp(null, el.querySelector(".services__grid")));
  }, []);

  return (
    <section id="services" className="services section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Products & Solutions</span>
        <h2 className="services__title">
          WHAT WE <span className="accent-text">OFFER</span>
        </h2>

        <div className="services__grid">
          <ul className="services__list">
            {services.map((service) => (
              <li
                key={service.id}
                className={`services__item ${
                  activeId === service.id ? "services__item--active" : ""
                }`}
                onMouseEnter={() => setActiveId(service.id)}
                onFocus={() => setActiveId(service.id)}
                tabIndex={0}
              >
                <span className="services__item-number">{service.number}</span>
                <span className="services__item-name">{service.name}</span>
                <p className="services__item-short">{service.short}</p>
              </li>
            ))}
          </ul>

          <div className="services__visual">
            <div
              className="services__visual-panel"
              style={active.image ? { backgroundImage: `url(${active.image})` } : undefined}
            >
              <div className="services__visual-scrim" />
              <div className="services__visual-info">
                <span className="services__visual-number">{active.number}</span>
                <h3>{active.name}</h3>
                <p>{active.description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
